
























































































































































































import { RegisterVue } from "fs-pb-vue2/vueModels/auth/RegisterVue";
import { Component } from "vue-property-decorator";
import { RegisterModel } from "fs-pb-vue2/models/auth/RegisterModel";
import i18n from "@/i18n";

@Component({})
export default class Register extends RegisterVue {
  async mounted() {
    await this.init();
  }

  /**Метод для выполнения после успешного проведения */
  async afterExecute(): Promise<void> {
    this.loginDialogContent = i18n.t("auth.messages.successregister", { login: (this.OperationModel as RegisterModel).Phone }).toString();;
    this.loginDialog = true;
  }  
}
